import React from 'react';
import { CardChoice } from '../../types';
import style from './choice.module.scss';
import DragIcon from '../../../../../../../../assets/svg/solo-chat/drag-handle-2.svg';
import { DeleteIcon } from '../../../../icons';

export type TChoice = CardChoice['contentValue']['choices'][0];

type Props = {
	index: number;
	updateChoice: (key: keyof TChoice, value: any, index: number) => void;
	removeChoice: (index: number) => void;
	choice: TChoice;
	mode: 'view' | 'edit' | 'create';
	isAutocomplete: boolean;
	error: Record<string, string> | undefined
	clearError: (index: number, key: string) => void
};

export function Choice(props: Props) {
	const { choice, index, updateChoice, removeChoice, mode, isAutocomplete, error = {}, clearError } =
		props;
	return (
		<div className={style.choiceWrapper}>
			<div className={style.choice}>
				{mode !== 'view' && (
					<div className="drag-handle">
						<img src={DragIcon} alt="drag" />
					</div>
				)}
				<div className={style.main}>
					<div className={style.form}>
						<div className={style.label} style={{ width: isAutocomplete ? '250px' : 137 }}>
							<label htmlFor="choiceId">Id</label>
							<input
								autoFocus
								disabled={mode === 'view'}
								id="choiceId"
								placeholder="Enter id"
								value={choice.id}
								onChange={(e) => {
									clearError(index, "id")
									const value = e.currentTarget.value;
									updateChoice('id', value, index);
								}}
							/>
							<span className={style.error}>{error.id}</span>
						</div>
						<div className={style.label} style={{ width: isAutocomplete ? '100%' : 155 }}>
							<label htmlFor="choiceLabel">Label</label>
							<input
								disabled={mode === 'view'}
								id="choiceLabel"
								placeholder="Enter label"
								value={choice.label}
								onChange={(e) => {
									clearError(index, "label")
									const value = e.currentTarget.value;
									updateChoice('label', value, index);
								}}
							/>
							<span className={style.error}>{error.label}</span>
						</div>
						{!isAutocomplete && (
							<div className={style.desc}>
								<label htmlFor="choiceDesc">
									Description
								</label>
								<input
									disabled={mode === 'view'}
									id="choiceDesc"
									placeholder="Enter description"
									value={choice.description}
									onChange={(e) => {
										clearError(index, "description")
										const value = e.currentTarget.value;
										updateChoice('description', value, index);
									}}
								/>
								<span className={style.error}>{error.description}</span>
							</div>
						)}
					</div>
				</div>
			</div>
			{mode !== 'view' && (
				<button onClick={() => removeChoice(index)}>
					<DeleteIcon width="13" height="13" stroke="#D30000" />
					<span>Delete</span>
				</button>
			)}
		</div>
	);
}
